import axios from "axios";
const host = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");

export async function fetchSettingsApi() {
  const res = await axios.get(`${host}api/missionControl/settings/get`, {
    headers: {
      token,
    },
  });
  // const res = await axios({
  //   url: host + "api/missionControl/settings/get",
  //   method: "GET",
  //   headers: { token: token },
  // });
  return res;
}

export async function getRegistrationStatus() {
  const res = await axios.get(`${host}api/general/isRegistrationOpen`);
  // const res = await axios({
  //   url: host + "api/general/isRegistrationOpen",
  //   method: "GET",
  // });
  return res;
}

export async function setAssignmentApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/assignMentor`, values, { headers: { token } }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/assignMentor",
  //   method: "POST",
  //   headers: { token: token },
  //   data: {},
  // });
  return res;
}

export async function addDomainApi(values) {
  const res = await axios.post(`${host}api/general/addDomain`, values, {
    headers: { token },
  });
  // const res = await axios({
  //   url: host + "api/general/addDomain",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}
export async function fetchDomainApi() {
  const res = await axios.get(`${host}api/general/domains/get`, {
    headers: {
      token,
    },
  });
  return res;
}

export async function makeAdminApi(values) {
  const res = await axios.post(`${host}api/missionControl/addAdmin`, values, {
    headers: { token },
  });
  // const res = await axios({
  //   url: host + "api/missionControl/addAdmin",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}

export async function handleSettingApi(values) {
  const res = await axios.post(
    `${host}api/missionControl/settings/update`,
    values, {
      headers: { token },
    }
  );
  // const res = await axios({
  //   url: host + "api/missionControl/settings/update",
  //   method: "POST",
  //   headers: { token: token },
  //   data: values,
  // });
  return res;
}